<template>
  <div class="columns">
    <div class="column is-8">
      <section class="spacing-top">
        <b-table
          :data="slips"
          :paginated="true"
          :pagination-simple="false"
          :per-page="15"
          default-sort-direction="'asc'"
          default-sort="number">
          <template slot-scope="slip">
            <b-table-column field="number" width="100" label="Nr." sortable numeric>
              {{ slip.row.number }}
            </b-table-column>
            <b-table-column field="crediteur" label="Crediteur" sortable>
              {{ slip.row.crediteur | crediteur }}
            </b-table-column>
            <b-table-column field="date" label="Datum" sortable>
              {{ slip.row.date | date('DD/MM/YYYY') }}
            </b-table-column>
            <b-table-column field="journal" label="Grootboekrekening" sortable>
              {{ slip.row.journal }}
            </b-table-column>
            <b-table-column field="price" label="Prijs" sortable>
              € {{ slip.row.price }}
            </b-table-column>
            <b-table-column>
              <button class="button is-primary" @click="completed(slip.row.id)">Afgerond</button>
            </b-table-column>
          </template>
        </b-table>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      slips: 'confirmedCreditcardslips'
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getCrediteuren')
      await this.$store.dispatch('getConfirmedCreditcardslips')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens ophalen van de creditcard slips.'
      })
    }
  },
  methods: {
    async completed (id) {
      await this.$store.dispatch('setCreditcardslipState', {
        state: 'completed',
        id
      })

      await this.$store.dispatch('getConfirmedCreditcardslips')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creditcard/confirmed.vue